import clsx from 'clsx';
import React from 'react';

import BaseButton, { BaseButtonProps } from '../BaseButton/BaseButton';
import styles from './TextButton.module.scss';

const arrow = (
  <svg className={styles.arrow} xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
    <path d="M3.245 10.065L4.13 10.95 9.08 6 4.13 1.05 3.245 1.935 7.31 6 3.245 10.065z" />
  </svg>
);

const textButtonFactory = (type: 'primary' | 'secondary' | 'basic' | 'transparent'): React.FC<BaseButtonProps> => {
  const TextButtonComp: React.FC<BaseButtonProps> = ({ children, className, disabled, ...props }) => {
    const klass = clsx(styles[type], disabled && styles.disabled, className);

    return (
      <BaseButton className={klass} disabled={disabled} {...props}>
        <div className={styles.container}>
          {children}
          {arrow}
        </div>
      </BaseButton>
    );
  };
  TextButtonComp.displayName = `TextButton-${type}`;

  return TextButtonComp;
};

/**
 * 단순 텍스트로만 구성된 버튼, 혹은 링크.
 *
 * @see https://zpl.io/VQ7Xq8A
 * @example
 * const viewAll = (
 *   <TextButton.Primary as="link" className={styles.viewAll} href="/" onClick={trackClickViewAll}>
 *     전체 보기
 *   </TextButton.Primary>
 * )
 *
 * const deleteAll = (
 *   <TextButton.Basic as="button" className={styles.deleteAll} onClick={store.deleteAll}>
 *     모두 삭제
 *   </TextButton.Basic>
 * )
 */
const TextButton = {
  /** 파랑. */
  Primary: textButtonFactory('primary'),
  /** 화살표 없음, 파랑. */
  Secondary: textButtonFactory('secondary'),
  /** 검정. */
  Basic: textButtonFactory('basic'),
  /** 하양. */
  Transparent: textButtonFactory('transparent'),
};

export default TextButton;
